import { DonHangMua, DonHangMuaChiTiet, KeHoachNCCGiaoHang } from './../don-hang-mua-page-model/don-hang-mua.model';
import { NgbTimeStringAdapter } from 'dps-lib';
import { NgbTimeAdapter } from '@ng-bootstrap/ng-bootstrap';
import { select } from '@ngrx/store';
import {Component,
		OnInit,
		ElementRef,
		ViewChildren,
		ViewChild,
		ChangeDetectionStrategy,
		ChangeDetectorRef,
		Inject,
		HostListener,
		Input
	}
from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
// Material
import { MatPaginator, MatSort, MatDialog, MatTableDataSource, MatMenuTrigger, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

// RXJS
import { ReplaySubject,BehaviorSubject } from 'rxjs';
//Service
import { DungChungService } from '../../../dung-chung/__services/dung-chung.service';
import { KhachHangService } from '../../../danh-muc/khach-hang/khach-hang-service/khach-hang.service';

import { SubheaderService } from '../../../../../../core/_base/layout';
import { LayoutUtilsService, MessageType, QueryParamsModel } from '../../../../../../core/_base/crud';
import { TokenStorage } from '../../../../../../core/auth/_services/token-storage.service';
//Model
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
import { CommonConFig, NhaCungCapModelLite } from '../../../dung-chung/__model/common_config.model';
import { SelectionModel } from '@angular/cdk/collections';
import { FunctionPublic } from '../../../dung-chung/__function/common_function';
import moment from 'moment';
import { DonHangMuaDataSource } from '../don-hang-mua-page-datasource/don-hang-mua.datasource';
import { DonHangMuaService } from '../don-hang-mua-page-service/don-hang-mua.service';
import { LichSuGiaoHang } from '../don-hang-mua-page-model/don-hang-mua.model';
import { environment } from '../../../../../../../environments/environment';

@Component({
	selector: 'kt-ke-hoach-ncc-giao-hang',
	templateUrl: './ke-hoach-ncc-giao-hang.component.html',
	styleUrls: ['../don-hang-mua-page.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [DatePipe, { provide: NgbTimeAdapter, useClass: NgbTimeStringAdapter }]
})

export class KeHoachNCCGiaoHangComponent implements OnInit {
	/*Config Form */
	CONFIG: CommonConFig;
	dataSource: DonHangMuaDataSource;

	/* Trigger menu hiển thị cột cho danh sách */
	@ViewChild('trigger', {static: true}) _trigger: MatMenuTrigger;

	/* Loading.... */
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	viewLoading = false;
	/* ------------------------------------------------------------------ */

	//#region Phím tắt
	@HostListener('window:keyup', ['$event'])
	keyEvent(event: KeyboardEvent) {
		if (event.keyCode == this.CONFIG.BUTTON_FORM.BACK.KeyCombine.keycode){
			this.back();
		}
	}
	//#endregion Phím tắt

	minDate = new Date();

	isShow : false;

	displayedColumns = [];
	availableColumns = [
        {
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true,
			type: 'number'
        },
        {
            stt: 2,
            name: 'SLGiao',
            displayName: 'SL Giao',
            alwaysChecked: false,
			isShow: true,
			type: 'number'
        },
		{
            stt: 4,
            name: 'GioTu',
            displayName: 'Giờ từ',
            alwaysChecked: false,
			isShow: true,
			type: 'time'
        },
        {
            stt: 5,
            name: 'GioDen',
            displayName: 'Đến',
            alwaysChecked: false,
			isShow: true,
			type: 'time'
		},
		{
            stt: 5,
            name: 'TrangThai',
            displayName: 'Trạng thái',
            alwaysChecked: false,
			isShow: true,
			type: 'string'
		},
		{
            stt: 5,
            name: 'ThaoTac',
            displayName: '',
            alwaysChecked: false,
			isShow: true,
			type: 'date'
		}
	];
	
	@ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
	@ViewChild('sort1', {static: true}) sort: MatSort;

	//filter on grid
	haveFilter: boolean = false;
	filterGroupDataChecked: any = {};
	filterGroupDataCheckedFake: any = {};
	filterGroupData: any = {};
	preFilterGroupData: any = {};
	filterGroupArray: any = {};
	filterText: any = {};
	tmpfilterText: any = {};
	disableButtonFilter: any = {};
	isClearAll: boolean = false;
	
	@Input() title: string = "KẾ HOẠCH NHÀ CUNG CẤP GIAO HÀNG";
	@Input() subTitle: string = "";

	SLMua: number = 0;

	DonHangMuaResult = [];
	tmpDonHangMuaResult = [];

	KeHoachNCCGiaoHangForm: FormGroup;
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selection = new SelectionModel<any>(true, []);

	ELEMENT_DATA : DonHangMuaChiTiet;

	constructor(
		public 	dialogRef2: MatDialogRef<KeHoachNCCGiaoHangComponent>,
		public 	dialog2: MatDialog,
		private changeDetect: ChangeDetectorRef,
		private service : DonHangMuaService,
		private layoutUtilsService: LayoutUtilsService,
		private formFB: FormBuilder,
		private el: ElementRef,
		@Inject(MAT_DIALOG_DATA) public data: any,
	) {this.dialogRef2.disableClose = true;}

	//#region Load Data
	async ngOnInit() {
		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();
		this.CONFIG.PAGE_SIZE_LIST = environment.pageSize;

		this.ELEMENT_DATA = this.data.data;

		this.isShow = this.data.dangsoanthao && this.data.nguoilapphieu && this.data.isThaoTac;

		if(this.ELEMENT_DATA.KeHoachNCCGiaoHang.length > 0){
			this.tmpDonHangMuaResult = this.ELEMENT_DATA.KeHoachNCCGiaoHang;
			this.tmpDonHangMuaResult = [...this.tmpDonHangMuaResult];
		}

		
		this.SLMua = this.ELEMENT_DATA.SoLuong - this.ELEMENT_DATA.SoLuongDaGiao;
		//this.callDanhSachKeHoachNCCGiaoHang();

		this.createForm();
		this.applySelectedColumns();
		this.changeDetect.detectChanges();
	}

	createForm(){
		// Form 1
		this.KeHoachNCCGiaoHangForm = this.formFB.group({
			SLDATMUA : [this.ELEMENT_DATA.SoLuong, Validators.compose([Validators.required,Validators.maxLength(24),Validators.pattern(this.CONFIG.REGEX_FORMAT_NUMBER)])],
			SLCHUALENKH : ['0,00', Validators.compose([Validators.required,Validators.maxLength(24),Validators.pattern(this.CONFIG.REGEX_FORMAT_NUMBER)])],
			SLGIAO : ['0,00', Validators.compose([Validators.required,Validators.maxLength(24),Validators.pattern(this.CONFIG.REGEX_FORMAT_NUMBER)])],
			TUNGAY: [new Date(), Validators.required],
			DENNGAY: [new Date(), Validators.required]
		});

		this.KeHoachNCCGiaoHangForm.controls['SLDATMUA'].disable();
		this.KeHoachNCCGiaoHangForm.controls['SLCHUALENKH'].disable();

		

		const reducer = (accumulator, currentValue) => Number(accumulator) + Number(currentValue);
		var SLDaLenKH =  this.tmpDonHangMuaResult.length == 0 ? 0 : this.tmpDonHangMuaResult.map(x => x.SoLuong).reduce(reducer);
		var SLChuaLenKH = +this.ELEMENT_DATA.SoLuong - (+SLDaLenKH);

		this.KeHoachNCCGiaoHangForm.controls['SLCHUALENKH'].setValue(SLChuaLenKH);
		this.KeHoachNCCGiaoHangForm.controls['SLGIAO'].setValue(this.f_number(SLChuaLenKH));
	}

	addHang(){
		
		const controls = this.KeHoachNCCGiaoHangForm.controls;
		/** check form */
		if (this.KeHoachNCCGiaoHangForm.invalid) {
			const invalidElements = this.el.nativeElement.querySelectorAll('.ng-invalid');
			//let indexList = [];
			if (invalidElements.length > 0) {
				for(let i = 0; i < invalidElements.length; i++){
					if(invalidElements[i].nodeName == 'INPUT' || invalidElements[i].nodeName == 'MAT-SELECT'){
						const elementControl = this.KeHoachNCCGiaoHangForm.get(invalidElements[i].attributes.getNamedItem("formcontrolname").value);
						if(elementControl){
							setTimeout(() => invalidElements[i].focus(), 100);
							break;
						}
					}
				}
			}
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);
			return;
		}

		if(+this.f_number(controls['SLGIAO'].value) <= 0){
			this.layoutUtilsService.showErorr("SL Giao không được nhỏ hơn 0,00!");
			return;
		}

		

		if(+this.f_number(controls['SLGIAO'].value) > +this.f_number(controls['SLCHUALENKH'].value) || +controls['SLCHUALENKH'].value == 0){
			this.layoutUtilsService.showErorr("SL Giao không được lớn hơn SL chưa lên KH!");
			return;
		}

		
		var SLDaThem : number = 0;
		this.tmpDonHangMuaResult.forEach(x => {SLDaThem += Number(x.SoLuong)});		
		SLDaThem += Number(this.f_number(controls['SLGIAO'].value));
		if((SLDaThem - this.SLMua) > 0.0099){
			this.layoutUtilsService.showErorr("Tổng số lượng kế hoạch ncc giao hàng vượt số lượng đơn hàng đã mua!");
			return;
		}

		var isFail = false;

		if(this.tmpDonHangMuaResult.length > 0){
			this.tmpDonHangMuaResult.forEach(x =>{
				if(x.SoLuong == Number(this.f_number(controls['SLGIAO'].value)) 
					&& moment(x.GioVe).format("DD/MM/YYYY HH:mm").toString() == moment(controls['TUNGAY'].value).format("DD/MM/YYYY HH:mm").toString()
					&& moment(x.GioDen).format("DD/MM/YYYY HH:mm").toString() == moment(controls['DENNGAY'].value).format("DD/MM/YYYY HH:mm").toString()
				){
					isFail = true;
				}
			});
		}
		
		if(isFail){
			this.layoutUtilsService.showErorr("Đã tồn tại SL giao, Giao từ ngày, Đến ngày trong danh sách");
			return;
		}

		let tn = new Date(moment(controls['TUNGAY'].value).format("MM/DD/YYYY HH:mm"));
		let dn = new Date(moment(controls['DENNGAY'].value).format("MM/DD/YYYY HH:mm"));
		let now = new Date();
		now.setHours(0,0,0,0);

		if(+tn.getTime() < +now.getTime()){
			this.layoutUtilsService.showErorr("Giao từ ngày không được nhỏ hơn ngày hiện tại");
			return;
		}

		if(+dn.getTime() < +now.getTime()){
			this.layoutUtilsService.showErorr("Giao đến ngày không được nhỏ hơn ngày hiện tại");
			return;
		}
		

		var From = +(new Date(moment(controls['TUNGAY'].value).format("MM/DD/YYYY HH:mm").toString())).getTime();
		var To = +(new Date(moment(controls['DENNGAY'].value).format("MM/DD/YYYY HH:mm").toString())).getTime();

		if(From > To){
			this.layoutUtilsService.showErorr("Giao từ ngày không được lớn hơn đến ngày");
			return;
		}

		var item = new KeHoachNCCGiaoHang();
		item.clear();

		item.HangHoa_Id = this.ELEMENT_DATA.IdHH;

		item.SoLuong = Number(this.f_number(controls['SLGIAO'].value));

		item.NgayVe = moment(controls['TUNGAY'].value).format('YYYY-MM-DD[T]00:00:00');
		
		item.GioVe = moment(controls['TUNGAY'].value).format('YYYY-MM-DD[T]HH:mm:ss');

		item.GioDen = moment(controls['DENNGAY'].value).format('YYYY-MM-DD[T]HH:mm:ss');

		item.DVT = this.ELEMENT_DATA.IdDVT;

		item.TrangThai = "Đang soạn thảo";

		this.tmpDonHangMuaResult.push(item);

		this.tmpDonHangMuaResult = [...this.tmpDonHangMuaResult];
		
		this.KeHoachNCCGiaoHangForm.reset();

		const reducer = (accumulator, currentValue) => Number(accumulator) + Number(currentValue);
		var SLDaLenKH =  this.tmpDonHangMuaResult.length == 0 ? 0 : this.tmpDonHangMuaResult.map(x => x.SoLuong).reduce(reducer);
		var SLChuaLenKH = +this.ELEMENT_DATA.SoLuong - (+SLDaLenKH);

		controls['SLDATMUA'].setValue(this.f_number(this.ELEMENT_DATA.SoLuong));
		controls['SLCHUALENKH'].setValue(SLChuaLenKH);
		controls['SLGIAO'].setValue(this.f_number(SLChuaLenKH));
		controls['TUNGAY'].setValue(new Date());
		controls['DENNGAY'].setValue(new Date());

		this.changeDetect.detectChanges();
	}

	deleteHang(index: number){
		this.tmpDonHangMuaResult.splice(index, 1);
		this.tmpDonHangMuaResult = [...this.tmpDonHangMuaResult];

		const controls = this.KeHoachNCCGiaoHangForm.controls;
		const reducer = (accumulator, currentValue) => Number(accumulator) + Number(currentValue);
		var SLDaLenKH =  this.tmpDonHangMuaResult.length == 0 ? 0 : this.tmpDonHangMuaResult.map(x => x.SoLuong).reduce(reducer);
		var SLChuaLenKH = +this.ELEMENT_DATA.SoLuong - (+SLDaLenKH);
		controls['SLCHUALENKH'].setValue(SLChuaLenKH);
		controls['SLGIAO'].setValue(this.f_number(SLChuaLenKH));

		this.changeDetect.detectChanges();
	}

	stringToTime(data: string){
		return moment(data, "HH:mm");
	}

	filterConfiguration(): any {
		const filter: any = {};
		return filter;
	}

	ngAfterViewInit() {
		this.changeDetect.detectChanges();
	}
	//#endregion Load Data

	//#region Quay về
	back(){
		this.dialogRef2.close({
			data : this.ELEMENT_DATA
		});
	}
	//#endregion Quay về

	applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		for(let i = 0; i < this.availableColumns.length; i++){
			this.selectedColumns.toggle(this.availableColumns[i]);
			for( let j = 0; j < _selectedColumns.length; j++){
				if( this.availableColumns[i].name == _selectedColumns[j].name){
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedColumns = _applySelectedColumns;
	}

	getFormatDate(v: string = '') {
        if (v != '') {
            return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
        }
        return '';
	}

	f_number(item: any = "0.00"){
		return FunctionPublic.F_NUMBER(item);
	}

	fomartData(data : any, type: string){
		switch(type){
			case 'number': return this.f_number(data);
			case 'string': return data;
			case 'date' : return this.getFormatDate(data);
			case 'time' : return moment(data).format("HH:mm");
			case 'datetime' : return moment(data).format("DD/MM/YYYY HH:mm");
			default: return data;
		}
	}

	checkTimeFromAndTo(){
		const [hFrom, mFrom] = (this.KeHoachNCCGiaoHangForm.controls['GIOTU'].value ? this.KeHoachNCCGiaoHangForm.controls['GIOTU'].value.toString() : "00:00").split(":").map(Number);
		const [hTo, mTo] = (this.KeHoachNCCGiaoHangForm.controls['GIODEN'].value ? this.KeHoachNCCGiaoHangForm.controls['GIODEN'].value.toString() : "00:00").split(":").map(Number);
		if(hFrom > hTo) return true;
		if(hFrom == hTo && mFrom > mTo) return true;
		return false;
	}

	keyUpInputNumberVND(event){
		FunctionPublic.preventAlphaV2(event);
	}

	changeInputNumberVND(event, columnName, min: number = 0, formGroup){
		let controls = formGroup.controls;
		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) { 
			event.preventDefault(); 
		}
		else{
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) 
			{ return; } 

			let data = FunctionPublic.slListChangedV2(event);
			if(data){
				if(this.f_number(data) <= min && event.data && event.data == '0') data = this.f_number(min);
				controls[columnName].setValue(data);
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;

				if(data.length == 4){
					event.target.selectionStart = position;
					event.target.selectionEnd = position;
				}
				
			}else{
				controls[columnName].setValue(this.f_number(min));
				event.target.selectionStart = 0;
				event.target.selectionEnd = 0;
			}
			
		}
	}

	changeInputOfFormVND(controlName: string, event: any, min: number = 0, formGroup){
		let controls = formGroup.controls;
		if(this.ValidateChangeNumberForm(event)){
			let tmpValue = event.target.value.replace(/\./g, "").replace(/,/g, ".");

			if(isNaN(tmpValue)) tmpValue = min;
			
			if(Number(tmpValue) < min) tmpValue = min;

			if(!controls[controlName].invalid){
				controls[controlName].setValue(
					this.f_number(tmpValue)
				);
			}
		
			controls[controlName].setValue(
				this.f_number(tmpValue)
			);

			event.target.value = this.f_number(tmpValue);
		}
		else{
			controls[controlName].setValue(this.f_number(min.toString()));
		}

		this.changeDetect.detectChanges();
		
	}

	ValidateChangeNumberForm(event: any, isEvent:boolean = true) {
		var count = 0;
		let data: string = '';
		if(isEvent){
			for(let i = 0; i < event.target.value.length; i++){
				if(event.target.value[i] == ','){
					count += 1;
				}
			}
			data = event.target.value;
		}
		else{
			for(let i = 0; i < event.length; i++){
				if(event[i] == ','){
					count += 1;
				}
			}
			data = event;
		}
		var regex = /[a-zA-Z -!$%^&*()_+|~=`{}[:;<>?@#\]]/g;
		var found = isEvent ? event.target.value.match(regex) : String(event).match(regex);
		if (found != null) {
			return false;;
		}
		if (count >= 2) {
			return false;;
		}
		return true;
	}

	luuKeHoachNCCGiaoHang(){
		if(this.tmpDonHangMuaResult.length == 0){
			this.layoutUtilsService.showErorr("Vui lòng thêm kế hoạch ncc giao hàng vào danh sách");
			return false;
		}

		var SLDatMua = Number(this.ELEMENT_DATA.SoLuong);

		const reducer = (accumulator, currentValue) => Number(accumulator) + Number(currentValue);
		var SLDaLenKH =  this.tmpDonHangMuaResult.length == 0 ? 0 : this.tmpDonHangMuaResult.map(x => x.SoLuong).reduce(reducer);

		if(+SLDatMua.toFixed(2) != +SLDaLenKH.toFixed(2)){
			this.layoutUtilsService.showErorr("Vui lòng kiểm tra SL đặt mua và tổng số lượng lên kế hoạch");
			return false;
		}

		this.ELEMENT_DATA.KeHoachNCCGiaoHang = [];
		this.ELEMENT_DATA.KeHoachNCCGiaoHang = this.tmpDonHangMuaResult;

		this.back();
	}

	getColorTrangThaiKeHoach(TrangThai: string){
		switch(TrangThai){
			case "Đang soạn thảo": return "#FF9900";
			case "Đã huỷ": return "#FF0000";
			case "Chờ xác nhận" : return "#02A7F0";
			case "Đang áp dụng": return "#009900"
		}
	}
}

